export default {
  namespaced: true,
  state: {
    iin: '',
    showSecondStepOfLoginPage: false,
    loginBiometryMode: false,
    loginBiometrySuccess: false,
    passwordResetMode: false,
    sessionId: null
  },
  getters: {
    iin: state => state.iin,
    showSecondStepOfLoginPage: state => state.showSecondStepOfLoginPage,
    loginBiometryMode: state => state.loginBiometryMode,
    loginBiometrySuccess: state => state.loginBiometrySuccess,
    passwordResetMode: state => state.passwordResetMode,
    sessionId: state => state.sessionId
  },
  mutations: {
    SET_IIN(state, value) {
      state.iin = value
    },
    SET_SHOW_SECOND_STEP_OF_LOGIN_PAGE(state, value) {
      state.showSecondStepOfLoginPage = value
    },
    SET_LOGIN_BIOMETRY_MODE(state, value) {
      state.loginBiometryMode = value
    },
    SET_LOGIN_BIOMETRY_SUCCESS(state, value) {
      state.loginBiometrySuccess = value
    },
    SET_PASSWORD_RESET_MODE(state, value) {
      state.passwordResetMode = value
    },
    SET_SESSION_ID(state, value) {
      state.sessionId = value
    }
  },
  actions: {
    setIin({commit}, iin) {
      commit('SET_IIN', iin)
    },
    setShowSecondStepOfLoginPage({commit}, showSecondStepOfLoginPage) {
      commit('SET_SHOW_SECOND_STEP_OF_LOGIN_PAGE', showSecondStepOfLoginPage)
    },
    setLoginBiometryMode({ commit }, value) {
      commit('SET_LOGIN_BIOMETRY_MODE', value)
    },
    setLoginBiometrySuccess({ commit }, value) {
      commit('SET_LOGIN_BIOMETRY_SUCCESS', value)
    },
    setPasswordResetMode({ commit }, value) {
      commit('SET_PASSWORD_RESET_MODE', value)
    },
    setSessionId({ commit }, value) {
      commit('SET_SESSION_ID', value)
    }
  },
}
